// eslint-disable-next-line import/no-named-as-default
import { api } from './base.service';

export const getShiftTypes = (atcu) => {
  if (atcu) {
    return api().get(`/api/configs/shifts/${atcu}`);
  }
};

export const getAbsenceTypes = () => {
  return api().get('/api/configs/absences');
};

export const getAllMonthlyPlans = (atcu, year, version) => {
  if (atcu && year && version) {
    return api().get(`/api/schedules/monthly/${atcu}/${year}/${version}`);
  }
};

export const getPlanStatus = (atcu, year, month, version) => {
  if (atcu && year && month && version) {
    return api().get(`/api/schedules/monthly/${atcu}/${year}/${month}/${version}`);
  }
};

export const getScheduleContent = (atcu, year, month, version) => {
  if (atcu && year && month && version) {
    return api().get(`/api/schedules/monthly/${atcu}/${year}/${month}/${version}/content`);
  }
};

export const getScheduleDemand = (atcu, year, month, version) => {
  if (atcu && year && month && version) {
    return api().get(`/api/schedules/monthly/${atcu}/${year}/${month}/${version}/demand`);
  }
};

export const getScheduleVersions = (atcu, year, month) => {
  if (atcu && year && month) {
    return api().get(`/api/schedules/monthly/${atcu}/${year}/${month}/all`);
  }
};

export const saveModifiedMonthlySchedule = (scheduleId, modifiedData) => {
  if (scheduleId && modifiedData) {
    return api().post(`/api/save/monthly/${scheduleId}`, modifiedData);
  }
};

export const saveMonthlyScheduleAsNewVersion = (scheduleId, modifiedData) => {
  if (scheduleId && modifiedData) {
    return api().post(`/api/save/new/monthly/${scheduleId}`, modifiedData);
  }
};

export const getScheduleAll = (atcu, year) => {
  if (atcu && year) {
    return api().get(`/api/schedules/monthly/${atcu}/${year}/all`);
  }
}

export const regenerateMonth = (monthlyId) => {
  if (monthlyId) {
    return api().patch(`/api/save/regenerate/monthly/${monthlyId}`);
  }
}

export const submitMonthlyPlan = (scheduleId) => {
  if (scheduleId) {
    return api().patch(`/api/save/submit/monthly/${scheduleId}`);
  }
};

export const approveMonthlySchedule = (scheduleId) => {
  if (scheduleId) {
    return api().patch(`/api/save/approve/monthly/${scheduleId}`);
  }
};

export const rejectMonthlySchedule = (scheduleId) => {
  if (scheduleId) {
    return api().patch(`/api/save/reject/monthly/${scheduleId}`);
  }
};

export const getMonthlyScheduleChangelog = (atcu, year, month, version) => {
  if (atcu && year && month && version) {
    return api().get(`/api/schedules/monthly/${atcu}/${year}/${month}/${version}/changelog`);
  }
};
